function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_935",
  "data-name": "Group 935",
  transform: "translate(-800 -269)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_37",
  "data-name": "Ellipse 37",
  transform: "translate(800 269)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 6.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("line", {
  id: "Line_46",
  "data-name": "Line 46",
  x2: 6,
  y2: 6,
  transform: "translate(813.5 282.5)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 3
}));

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.621,
    height: 21.621,
    viewBox: "0 0 21.621 21.621",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.f750ca10.svg";
export { ForwardRef as ReactComponent };